export const dogBreedList = [
    "American water spaniel",
    "Barbet",
    "Boykin spaniel",
    "Bracco Italiano",
    "Brittany",
    "Chesapeake Bay retriever",
    "Clumber spaniel",
    "Cocker spaniel",
    "Curly-coated retriever",
    "English setter",
    "English springer spaniel",
    "Field spaniel",
    "Flat-coated retriever",
    "German shorthaired pointer",
    "German wirehaired pointer",
    "Golden retriever",
    "Gordon setter",
    "Irish setter",
    "Irish water spaniel",
    "Labrador retriever",
    "Lagotto Romagnolo",
    "Nederlandse Kooikerhondje",
    "Nova Scotia duck tolling retriever",
    "Pointer",
    "Spinone Italiano",
    "Sussex spaniel",
    "Vizsla",
    "Weimaraner",
    "Welsh Springer spaniel",
    "Wirehaired pointing griffon",
    "Wirehaired vizsla",
    "Afghan hound",
    "American English coonhound",
    "American foxhound",
    "Azawakh",
    "Basenji",
    "Basset hound",
    "Beagle",
    "Black and tan coonhound",
    "Bloodhound",
    "Bluetick coonhound",
    "Borzoi",
    "Cirneco dell'Etna",
    "Dachshund",
    "English foxhound",
    "Grand Basset Griffon Vendéen",
    "Greyhound",
    "Harrier",
    "Ibizan hound",
    "Irish wolfhound",
    "Norwegian elkhound",
    "Otterhound",
    "Pharaoh hound",
    "Plott hound",
    "Portuguese Pondengo Pequeno",
    "Redbone coonhound",
    "Rhodesian ridgeback",
    "Saluki",
    "Scottish deerhound",
    "Sloughi",
    "Treeing Walker coonhound",
    "Affenpinscher",
    "Brussels Griffon",
    "Cavalier King Charles spaniel",
    "Chihuahua",
    "Chinese Crested",
    "English toy spaniel",
    "Havanese",
    "Italian greyhound",
    "Japanese chin",
    "Maltese",
    "Machester terrier",
    "Miniature pinscher",
    "Papillon",
    "Pekingese",
    "Pomeranian",
    "Toy poodle",
    "Pug",
    "Russian toy",
    "Shih tzu",
    "Silky terrier",
    "Toy fox terrier",
    "Yorkshire terrier",
    "American Eskimo dog",
    "Bichon frise",
    "Boston terrier",
    "Bulldog",
    "Chinese shar-pei",
    "Chow chow",
    "Coton de Tulear",
    "Dalmatian",
    "Finnish spitz",
    "French bulldog",
    "Keeshond",
    "Lhasa Apso",
    "Löwchen",
    "Norwegian lundehund",
    "Poodle",
    "Schipperke",
    "Shiba Inu",
    "Tibetan spaniel",
    "Tibetan terrier",
    "Xoloitzcuintli",
    "Akita",
    "Alaskan Malamute",
    "Anatolian shepherd dog",
    "Bernese Mountain Dog",
    "Black Russian terrier",
    "Boerboel",
    "Boxer",
    "Bullmastiff",
    "Cane corso",
    "Chinook",
    "Doberman Pinscher",
    "Dogo Argentino",
    "Dogue de Bordeaux",
    "German pinscher",
    "Giant schnauzer",
    "Great Dane",
    "Great Pyrenees",
    "Greater Swiss mountain dog",
    "Komondor",
    "Kuvasz",
    "Leonberger",
    "Mastiff",
    "Neapolitan mastiff",
    "Newfoundland",
    "Portuguese water dog",
    "Rottweiler",
    "Saint Bernard",
    "Samoyed",
    "Siberian husky",
    "Standard schnauzer",
    "Tibetan mastiff",
    "Australian cattle dog",
    "Australian shepherd",
    "Bearded collie",
    "Beauceron",
    "Belgian Laekenois",
    "Belgian Malinois",
    "Belgian sheepdog",
    "Belgian Tervuren",
    "Bergamasco sheepdog",
    "Berger Picard",
    "Border collie",
    "Bouvier de Flandres",
    "Briard",
    "Canaan dog",
    "Cardigan Welsh corgi",
    "Collie",
    "Entlebucher mountain dog",
    "Finnish lapphund",
    "German Shepherd",
    "Icelandic sheepdog",
    "Miniature American shepherd",
    "Mudi",
    "Norwegian buhund",
    "Old English Sheepdog",
    "Pembroke Welsh corgi",
    "Polish lowland sheepdog",
    "Puli",
    "Pumi",
    "Pyrenean shepherd",
    "Shetland sheepdog",
    "Spanish water dog",
    "Swedish vallhund",
    "Airedale terrier",
    "American Staffordshire terrier",
    "Australian terrier",
    "Bedlington terrier",
    "Border terrier",
    "Bull terrier",
    "Cairn terrier",
    "Cesky terrier",
    "Dandie Dinmont terrier",
    "Glen of Imaal terrier",
    "Irish terrier",
    "Kerry blue terrier",
    "Lakeland terrier",
    "Manchester terrier",
    "Miniature bull terrier",
    "Miniature schnauzer",
    "Norfolk terrier",
    "Norwich terrier",
    "Parson Russell terrier",
    "Rat terrier",
    "Russell terrier",
    "Scottish terrier",
    "Sealyham terrier",
    "Skye terrier",
    "Smooth fox terrier",
    "Soft coated wheaten terrier",
    "Staffordshire bull terrier",
    "Welsh terrier",
    "West highland white terrier",
    "Wire fox terrier",
    "American pit bull terrier",
    "Bernedoodle",
    "Cavapoo",
    "Chiweenie",
    "Chug",
    "Czechoslovakian Vlca",
    "Goldendoodle",
    "King shepherd",
    "Poochon",
    "Shih-poo",
    "Texas heeler"
];
